import { Typography } from 'antd'

import { DataEmpty } from '@eastcoal/common/components/DataEmpty'
import { system } from '@eastcoal/common/config/system'
import { Noop } from '@eastcoal/common/types/utilities'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

type DictEmptyProps = {
  code: string
  loading?: boolean
  reload: Noop
}

export const DictEmpty = ({ code, loading, reload }: DictEmptyProps) => {
  return (
    <DataEmpty
      icon={false}
      loading={loading}
      reload={reload}
      message={
        <span>
          编码为
          <Typography.Text code copyable>
            {code}
          </Typography.Text>
          的字典
        </span>
      }
      to={stringifyUrl({
        url: system.router.operationBaseUrl + '/system/dict/create',
        query: { code }
      })}
    />
  )
}
